var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "grid_table_holder" }, [
    _c("table", { staticClass: "table_basic" }, [
      _c(
        "tbody",
        [
          _c("tr", [
            _c("th", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "CELL_BID_ID",
                  expression: "'CELL_BID_ID'"
                }
              ],
              attrs: { scope: "row" }
            }),
            _vm._v(" "),
            _c("td", [
              _c(
                "div",
                { staticClass: "overflow-ellipsis" },
                [
                  _c(
                    "TruncatedTextCopy",
                    { attrs: { "copy-text": _vm.bidRecord.bidId } },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.bidRecord.bidId) +
                          "\n            "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "CELL_BID_TIMESTAMP",
                  expression: "'CELL_BID_TIMESTAMP'"
                }
              ],
              attrs: { scope: "row" }
            }),
            _vm._v(" "),
            _c("td", [
              _c(
                "div",
                { staticClass: "overflow-ellipsis" },
                [
                  _c(
                    "TruncatedTextCopy",
                    {
                      attrs: {
                        "copy-text": _vm.getTimestamp(_vm.bidRecord.bidDt)
                      }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.getTimestamp(_vm.bidRecord.bidDt)) +
                          "\n            "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _vm._l(_vm.parsedData, function(row, index) {
            return _c("tr", { key: index }, [
              _c("th", { attrs: { scope: "row", valign: "top" } }, [
                _vm._v(_vm._s(_vm._f("camelCaseFormat")(row.name)))
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "overflow-ellipsis" },
                  [
                    _c(
                      "TruncatedTextCopy",
                      { attrs: { "copy-text": row.value } },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(row.value) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    row.name === "reasonForReject"
                      ? _c("div", { staticClass: "basic-link__wrapper" }, [
                          _c("a", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "LEARN_MORE",
                                expression: "'LEARN_MORE'"
                              }
                            ],
                            staticClass: "basic-link text-underline",
                            attrs: {
                              href:
                                "https://support.ringba.com/en-us/article/rtb-error-codes-63832r/?bust=1672863848404",
                              target: "_blank"
                            }
                          }),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "fa fa-external-link m-l-5 display-none",
                            attrs: { "aria-hidden": "true" }
                          })
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }